import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

interface StickyBoxProps {
  background?: string;
}

export const CostCodeDetailStyled = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-left: ${theme.spacings[400]};
    margin-right: ${theme.spacings[400]};
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 2px 1px -1px rgb(0 0 0 / 12%), 0 1px 1px 0 rgb(0 0 0 / 14%);
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  `};
`;
export const StickyBoxStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})<StickyBoxProps>`
  position: sticky;
  left: 0;
  z-index: 1;
  ${({ theme, background }) => css`
    background-color: ${background === 'white' ? theme.colors.white : theme.colors.grey[200]};
  `};
`;
